import { Injectable, inject } from '@angular/core';
import { Observable, filter, map, skip } from 'rxjs';
import { NetworkStatusService } from '../services/networkStatusService/network-status.service';
import { SyncEngine } from './sync-engine.service';

/** how often isOffline() asks the server again while it counts as not reachable (review W7, step 2) */
export const REACHABILITY_PROBE_MS = 15_000;

/**
 * «Offline» for the modules (Baujournal, Aufgaben): no network or the server not reachable (result of the last health
 * check). «unreachable» stays until the next check; with an empty or backed-off outbox no sync run sends one, so this
 * asks the server again, at most every 15 s.
 */
@Injectable({ providedIn: 'root' })
export class OfflineModeService {
  private readonly network = inject(NetworkStatusService);
  private readonly engine = inject(SyncEngine);
  /** test seam: clock in ms */
  now: () => number = () => Date.now();
  private lastProbe = Number.NEGATIVE_INFINITY;
  /** the server answers again (health check «online»); pages leave their offline mode (step-2 parked point) */
  readonly online$: Observable<void> = this.network.reachability$.pipe(
    skip(1),
    filter((value) => value === 'online'),
    map(() => undefined),
  );

  isOffline(): boolean {
    if (!navigator.onLine) return true;
    if (this.network.reachability$.value === 'online') return false;
    if (this.now() - this.lastProbe >= REACHABILITY_PROBE_MS) {
      this.lastProbe = this.now();
      void this.engine.checkReachable();
    }
    return true;
  }
}
